<script lang="ts" setup>
import { Card, CardHeader, CardTitle, CardDescription, CardFooter, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Store } from "lucide-vue-next";
import { myStoresFiltered, myStores, searchQuery } from './MyStoresStore'
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { addListeningStore, MySettingsStore, removeListeningStore } from "./MySettingsStore";
import { Button } from "@/components/ui/button";
import { Dialog, DialogTrigger, DialogHeader, DialogTitle, DialogDescription, DialogScrollContent } from "@/components/ui/dialog";
import Notifications from "./NotificationsView.vue";
// import StoreChartView from "@orders-spa-vue/pages/StoreChartView.vue";
import { cachedStoreOrders } from "./RecentOrdersStore";
import { printHTML } from "./printHTML";
import { currentPrinter } from "./getPrinters";
import { copies } from "./copiesNumber";
import { Badge } from "@/components/ui/badge";

const printBreakdown = (html: string) => {
    printHTML(html, currentPrinter.value?.deviceName || '', copies.value || 1);
}

</script>
<template>
    <div>


        <div class="mb-4 mt-4"
             v-if="myStores.length > 9">
            <Input v-model="searchQuery"
                   placeholder="Search by name or address"
                   class="max-w-sm" />
        </div>
        <div class="mb-4"
             v-if="myStores.length === 0">
            <p class="text-sm text-muted-foreground">
                No stores found.
            </p>
        </div>
        <div class="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
            <div v-for="store in myStoresFiltered"
                 :key="store.id"
                 class="block">
                <Card class="hover:bg-card/70 transition-colors">
                    <CardHeader>
                        <CardTitle class="text-lg">
                            <Store class="inline-block mr-1" />
                            {{ store.name }}
                            <Badge v-if="store.isListeningOrders > 0 || MySettingsStore[store.id]?.isEnabled">Online
                            </Badge>
                            <Badge v-else
                                   variant="destructive">Offline</Badge>
                        </CardTitle>
                        <CardDescription>{{ store.address1 }}</CardDescription>
                    </CardHeader>
                    <CardContent class="mt-4">
                        <div class="flex items-center gap-2">
                            <Label for="store-{{ store.id }}">
                                {{ MySettingsStore[store.id]?.isEnabled ? 'Enabled' : 'Disabled' }}
                            </Label>
                            <Switch id="store-{{ store.id }}"
                                    :checked="MySettingsStore[store.id]?.isEnabled"
                                    @update:checked="($event) => {
                                        if ($event) {
                                            addListeningStore(store.id);
                                        } else {
                                            removeListeningStore(store.id);
                                        }
                                    }" />
                        </div>
                    </CardContent>
                    <CardFooter>
                        <div class="space-y-2">

                            <Dialog>
                                <DialogTrigger>
                                    <Button variant="outline"
                                            size="lg">
                                        Support & Notifications
                                    </Button>
                                </DialogTrigger>
                                <DialogScrollContent>
                                    <DialogHeader>
                                        <DialogTitle>Support & Notifications</DialogTitle>
                                        <DialogDescription />
                                    </DialogHeader>

                                    <Notifications :store-id="store.id" />

                                </DialogScrollContent>
                            </Dialog>

                            <br>

                            <Dialog>
                                <DialogTrigger>
                                    <Button variant="outline"
                                            size="lg">
                                        Reports
                                    </Button>
                                </DialogTrigger>
                                <DialogScrollContent
                                                     class="sm:min-w-[90vw] md:min-w-[80vw] lg:min-w-[70vw] xl:min-w-[60vw]">
                                    <StoreChartView :current-store-id="store.id"
                                                    :cached-store-orders="cachedStoreOrders"
                                                    :is-print-breakdown-btn-visible="true"
                                                    @print-breakdown="printBreakdown" />
                                </DialogScrollContent>
                            </Dialog>
                        </div>
                    </CardFooter>
                </Card>
            </div>
        </div>
    </div>
</template>